import React from "react";
import { FaEye, FaUserSlash } from "react-icons/fa";
import deactivateSound from '../../assets/sounds/deactivate.mp3';
import "./AlunoCard.css";

const playSound = (src) => {
  const audio = new Audio(src);
  audio.play();
};

const AlunoCard = ({ aluno, onVisualizar, onDesativar }) => {
  return (
    <div className="aluno-card">
      <span className="nome-hover" onClick={() => onVisualizar(aluno)}>
        <FaEye />{aluno.codigo_aluno} - {aluno.nome_completo}
      </span>
      <div className="acoes">
        <button className="btn-vermelho"
  onClick={() => {
    if (window.confirm(`Pretende desativar o (a) aluno(a) ${aluno.nome_completo}?`)) {
      onDesativar(aluno.id);
      playSound(deactivateSound); // 🔊 Toca o som após desativar
    }
  }}
>
  <FaUserSlash /> Desativar
</button>


      </div>
    </div>
  );
};

export default AlunoCard;
